import myIndex from '../components/my/index'
import myCustomized from '../components/my/customized'
import myCustomizedCCIC from '../components/my/customizedDadi'
import myCustomizedTPL from '../components/my/customizedForklift'
import myCustomizedLineWork from '../components/my/customizedLineWork'

// 订单
import OrderIndex from '../components/my/order/index';
// 保单
import PolicyIndex from '../components/my/policy/index';
// 订单详情
import MyOrderDetail from '../components/my/order/Detail';

// 批单
import riderIndex from '../components/my/rider/index';
// 批单详情
import myRiderDetail from '../components/my/rider/Detail';


// 定制雇主责任险 
import TaskIndex from '../components/my/customized/task';
import PolicyCustomized from '../components/my/customized/policy';
import OrderCustomized from '../components/my/customized/order';
import CorrectionCustomized from '../components/my/customized/correction';
import DraftCustomized from '../components/my/customized/draft';

import CorrectionDet from '../components/my/customized/correctionDet';

import taskDetail from '../components/my/customized/taskDetial';

// 定制大地人资
import dadiOrderIndex from '../components/my/customizedDadi/order/index';
import dadiPolicyIndex from '../components/my/customizedDadi/policy/index';
import RiderIndex from '../components/my/customizedDadi/rider/index';
import InsuranceIndex from '../components/my/customizedDadi/insurance/index';
import DraftsIndex from '../components/my/customizedDadi/drafts/index';

// 保单详情
import dadiMyPolicyDetail from '../components/my/customizedDadi/policy/detail';
// 订单详情
import dadiMyOrderDetail from '../components/my/customizedDadi/order/detail';
// 批单详情
import dadiMyRiderDetail from '../components/my/customizedDadi/rider/detail';
// 投保单详情
import dadiMyInsuranceDetail from '../components/my/customizedDadi/insurance/detail';

// 物流特三
import TPLPolicyIndex from '../components/my/customizedForklift/policy/index';
import TPLRiderIndex from '../components/my/customizedForklift/rider/index';
import TPLInsuranceIndex from '../components/my/customizedForklift/insurance/index';
// 保单详情
import TPLMyPolicyDetail from '../components/my/customizedForklift/policy/detail';
// 批单详情
import TPLMyRiderDetail from '../components/my/customizedForklift/rider/detail';
// 投保单详情
import TPLMyInsuranceDetail from '../components/my/customizedForklift/insurance/detail';

// 同线工人
import LineWorkPolicyIndex from '../components/my/customizedLineWork/policy/index';
import LineWorkRiderIndex from '../components/my/customizedLineWork/rider/index';
import LineWorkInsuranceIndex from '../components/my/customizedLineWork/insurance/index';
// 保单详情
import LineWorkMyPolicyDetail from '../components/my/customizedLineWork/policy/detail';
// 批单详情
import LineWorkMyRiderDetail from '../components/my/customizedLineWork/rider/detail';
// 投保单详情
import LineWorkMyInsuranceDetail from '../components/my/customizedLineWork/insurance/detail';
// 人员明细
import LineWorkPersonnelIndex from '../components/my/customizedLineWork/personnel/index';

export default [
    {
        path: '',
        component: myIndex,
        children: [
            {
                path: 'order',
                name: 'my-order',
                component: OrderIndex
            },
            {
                path: 'policy',
                name: 'my-policy',
                component: PolicyIndex
            },
            {
                path: 'rider',
                name: 'my-rider',
                component: riderIndex
            }
        ]
    },

    {
        path: 'order-detail/:id/:type?',
        component: MyOrderDetail,
        name: 'my-order-detail'
    },
    {
        path: 'policy-detail/:id/:type?',
        component: MyOrderDetail,
        name: 'my-policy-detail'
    },
    {
        path: 'rider-detail/:id/:type?',
        component: myRiderDetail,
        name: 'my-rider-detail'
    },
    {
        path: 'customized',
        component: myCustomized,
        children: [
            {
                path: 'task',
                name: 'my-task',
                component: TaskIndex
            },
            {
                path: 'policy',
                name: 'my-policy',
                component: PolicyCustomized
            },
            {
                path: 'order',
                name: 'my-order',
                component: OrderCustomized
            },
            {
                path: 'correction',
                name: 'my-correction',
                component: CorrectionCustomized
            },
            {
                path: 'draft',
                name: 'my-draft',
                component: DraftCustomized
            }


        ]
    },
    {
        path:"customizedCCIC",
        component: myCustomizedCCIC,
        children: [
            {
                path:'order',
                name:'orderCCIC',
                component:dadiOrderIndex,
            },
            {
                path:'policy',
                component:dadiPolicyIndex,
                name:'policyCCIC'
            },
            {
                path:'rider',
                component:RiderIndex,
                name:'riderCCIC'
            },
            {
                path:'insurance',
                component:InsuranceIndex,
                name:'insuranceCCIC'
            },
            {
                path:'drafts',
                component:DraftsIndex,
                name:'draftsCCIC'
            },
            {
                path:'orderDetail/:id?',
                component:dadiMyOrderDetail,
                name:'orderCCIC'
            },
            {
                path:'policyDetail/:id?',
                component:dadiMyPolicyDetail,
                name:'policyCCIC'
            },
            {
                path:'riderDetail/:id?',
                component:dadiMyRiderDetail,
                name:'riderCCIC'
            },
            {
                path:'insuranceDetail/:id?',
                component:dadiMyInsuranceDetail,
                name:'insuranceCCIC'
            }
        ]
    },
    {
        path:"customizedTPL",
        component: myCustomizedTPL,
        children: [
            {
                path:'policy',
                component:TPLPolicyIndex,
                name:'policyTPL'
            },
            {
                path:'rider',
                component:TPLRiderIndex,
                name:'riderTPL'
            },
            {
                path:'insurance',
                component:TPLInsuranceIndex,
                name:'insuranceTPL'
            },
            {
                path:'policyDetail/:id?',
                component:TPLMyPolicyDetail,
                name:'policyTPL'
            },
            {
                path:'riderDetail/:id?',
                component:TPLMyRiderDetail,
                name:'riderTPL'
            },
            {
                path:'insuranceDetail/:id?',
                component:TPLMyInsuranceDetail,
                name:'insuranceTPL'
            }
        ]
    },
    {
        path:"customizedLineWork",
        component: myCustomizedLineWork,
        children: [
            {
                path:'policy',
                component:LineWorkPolicyIndex,
                name:'policyLineWork'
            },
            {
                path:'rider',
                component:LineWorkRiderIndex,
                name:'riderLineWork'
            },
            {
                path:'insurance',
                component:LineWorkInsuranceIndex,
                name:'insuranceLineWork'
            },
            {
                path:'personnel',
                component:LineWorkPersonnelIndex,
                name:'personnelLineWork'
            },
            {
                path:'policyDetail/:id?',
                component:LineWorkMyPolicyDetail,
                name:'policyLineWork'
            },
            {
                path:'riderDetail/:id?',
                component:LineWorkMyRiderDetail,
                name:'riderLineWork'
            },
            {
                path:'insuranceDetail/:id?',
                component:LineWorkMyInsuranceDetail,
                name:'insuranceLineWork'
            }
        ]
    },
    {
        path: 'taskDetail/:id',
        component: taskDetail,
    },
    {
        path: 'CorrectionDet',
        component: CorrectionDet,
    }

]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/my.js